const installationInstructions = {
  intro: {
    currentStep: 'intro',
    includeInstallationSteps: false,
    includePairingProcess: true,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a PowerTech Outlet!',
    resource: require('@/assets/device-models/PTO-01/pep-smart-outlet.png'),
    resourceType: 'image',
    secondaryText: "To get your device up and running we'll guide you through the ",
    continueButtonText: 'Get Started',
  },
  letsGetStarted: {
    additionalSecondaryTextClasses: 'section-seperator',
    continueButtonText: 'Get Started',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    primaryText: "Let's Get Started",
    secondaryText: 'To pair your PowerTech Outlet, you need the following:',
    steps: [
      {
        icon: require('@/assets/images/wifi-icon.png'),
        description: 'Strong Wi-Fi Network & Password'
      },
      {
        icon: require('@/assets/images/power-outlet-icon.png'),
        description: 'Power Source'
      }
    ],
    title: 'Pair Outlet'
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/PTO-01/pep-smart-outlet.png'),
    primaryText: 'Putting the PowerTech Outlet into Pairing Mode',
    secondaryText: 'If the LED is not double blinking green, the outlet is not in pairing mode. To manually put the outlet into pairing mode:',
    steps: [
      {
        title: 'TBD...',
        stepNumber: 1
      }
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    title: 'Re-Pair Outlet'
  }
};

export default installationInstructions;
